import React from 'react';
import { packages } from '../../data/packages';
import { BOOKING_URL } from '../../data/site';
import { PackageCard } from '../shared/PackageCard';
import { GiftCardVisual } from '../shared/GiftCardVisual';
import { ButtonLink } from '../ui/ButtonLink';
import { SectionHeading } from '../ui/SectionHeading';
const featuredIds = ['p1', 'p5', 'p8'];
export function PackagesTeaser() {
  const featured = packages.filter(p => featuredIds.includes(p.id));
  return <section className="gutter section brushed" aria-labelledby="packages-title" data-id="element-206" data-mp="1is3q45agtpuq">
      <SectionHeading id="packages-title" tone="dark" title="Train More. Save More." intro="Bundle courses from our recommended sequence and lock in package pricing." action={<ButtonLink to="/packages" variant="outline-light" data-id="element-208" data-mp="21kfusyold381">
            Compare all 8 packages
          </ButtonLink>} data-id="element-207" data-mp="1nqyahbo2zmgy" />
      <div className="mt-12 grid gap-6 xl:grid-cols-12" data-id="element-209" data-mp="26ir0qybrmtkz">
        <ul className="grid gap-5 md:grid-cols-3 xl:col-span-8" data-id="element-210" data-mp="26h6bno8802ui">
          {featured.map(p => <li key={p.id} data-id="element-211" data-mp="2ip8fmdaufnau">
              <PackageCard pkg={p} tone="dark" data-id="element-212" data-mp="2ioz0jkrc70jx" />
            </li>)}
        </ul>
        <div id="gift-teaser" className="flex flex-col justify-between gap-8 rounded-[4px] bg-ink/60 p-7 ring-1 ring-chrome-300/20 md:flex-row md:items-center xl:col-span-4 xl:flex-col xl:items-stretch" data-id="element-213" data-mp="2dpm2e3v0m721">
          <GiftCardVisual className="md:max-w-[26rem] xl:max-w-none" data-id="element-214" data-mp="36fb46jfjub4p" />
          <div data-id="element-215" data-mp="36gmbgt87e10k">
            <h3 className="t-h3 text-white" data-id="element-216" data-mp="31fylmavpnq7x">Give the Gift of Self-Defense.</h3>
            <p className="mt-2 text-chrome-300" data-id="element-217" data-mp="31i2n6m650d51">Gift certificates cover any course or package — the most meaningful gift you can give someone you love.</p>
            <div className="mt-5 flex flex-wrap gap-3" data-id="element-218" data-mp="2rp3vgvfcg6h7">
              <ButtonLink href={BOOKING_URL} data-id="element-219" data-mp="3p50y74bhmsvk">Buy a Gift Certificate</ButtonLink>
            </div>
          </div>
        </div>
      </div>
    </section>;
}